import { endpoints } from 'api/endpoints'
import { GetArrayResponse, GetOneResponse } from 'interfaces/api.interfaces'
import { TetrisGroup, TetrisGroupBase } from 'interfaces/api/tetrisGroups.interfaces'
import { axios } from 'modules/axios'

const getAll = async (): GetArrayResponse<TetrisGroup> => {
  const { data: response } = await axios.request<TetrisGroup[]>({
    method: 'GET',
    url: endpoints.tetrisGroups.getAll(),
  })
  return response
}

const create = async (data: TetrisGroupBase): GetOneResponse<TetrisGroup> => {
  const { data: response } = await axios.request<TetrisGroup>({
    method: 'POST',
    url: endpoints.tetrisGroups.create(),
    data,
  })
  return response
}

const update = async (id: number, data: TetrisGroupBase): GetOneResponse<TetrisGroup> => {
  const { data: response } = await axios.request<TetrisGroup>({
    method: 'PATCH',
    url: endpoints.tetrisGroups.update(id),
    data,
  })
  return response
}

const remove = (id: number): Promise<void> =>
  axios.request({
    method: 'DELETE',
    url: endpoints.tetrisGroups.remove(id),
  })

export const tetrisGroupsApi = {
  create,
  getAll,
  update,
  remove,
}
